<template>
    <div class="response-preview">
        <json-intent
            v-if="response.type === 'JSON'"
            :intent="responseAnswer"
            :errors="{}"
            readonly
        />
        <flow-intent
            v-else-if="response.type === 'FLOW'"
            :intent="responseAnswer"
            :errors="{}"
            readonly
        />
        <text-intent
            v-if="response.type === 'TEXT'"
            class="text"
            :intent="responseAnswer"
            :errors="{}"
            readonly
        />
    </div>
</template>

<script>
import JsonIntent from '@/components/common/intent/types/json_intent'
import FlowIntent from '@/components/common/intent/types/flow_intent'
import TextIntent from '@/components/common/intent/types/text_intent'

export default {
  components: { JsonIntent, FlowIntent, TextIntent },
  props: {
    /** {
            answer      : String,
            answerId    : String,
            context     : String,
            contextId   : String,
            score       : Number,
            type        : String, // TEXT | FLOW | JSON

            confirmationPhrase: {
                type    : String,
                required: false,
            },
         */
    response: Object
  },

  computed: {
    responseAnswer () {
      if (this.response.type === 'FLOW') {
        return JSON.parse(this.response.answer)
      }
      return this.response.answer
    }
  }
}
</script>

<style lang="scss" scoped>
    .response-preview {

    }
</style>
